import axios from "axios";

const decimalControl = (num, numCal) => {
  const numberCalculation = Number(num) * numCal;
  if (numberCalculation % 1 !== 0) {
    return parseFloat(numberCalculation).toFixed(4);
  } else {
    return numberCalculation;
  }
};

const mathRound = (num, numCal) => {
  const numberCalculation = Number(num) * numCal;
  return Math.round(numberCalculation);
}

export const useForm = () => {


  const sendToHubSpot = (formData) => {
    const portalId = "2886100"; // replace with your HubSpot portal ID
    const formGuid = "df4c65be-00f2-46c5-815e-dfe24cb3425c"; // replace with your HubSpot form GUIDplace with your HubSpot form GUID
    const endpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
    const incrementalNetwork = formData.numberOfPlants < 5 ? "No Data Provided" : mathRound(formData.onHandInventory, 0.0289);
    
    const data = {
      fields: [
        { name: "firstname", value: formData.firstname },
        { name: "lastname", value: formData.lastname },
        { name: "email", value: formData.email },
        { name: "company", value: formData.company },
        {
          name: "cost_saving_calculator",
          value: `On-Hand-Inventory: ${Number(formData.onHandInventory)},
           Estimated 12 Months $ of MRO Spend: test: ${Number(
             formData.estimated12Months
           )},
           Number of Plants: ${Number(formData.numberOfPlants)},
           Number of SKUs on-Hand: ${Number(formData.numberOfSKUs)},
           Number of Employees: ${Number(formData.numberOfEmployees)},
           OverMax: ${mathRound(Number(formData.onHandInventory), 0.0303)},
           Pricing Gap: ${mathRound(
             Number(formData.estimated12Months),
             0.1031
           )}
           Material Optimization: ${mathRound(
             Number(formData.onHandInventory),
             0.0886
           )}
           Incremental Network Optimization: ${incrementalNetwork}
           `,
        },
      ],
      skipValidation: true, // Skip HubSpot validation; set to false if you want to validate data
    };
    axios
      .post(endpoint, data)
      .then((response) => {
        sessionStorage.setItem(
          "OverMax",
          JSON.stringify(
            mathRound(Number(formData.onHandInventory), 0.0303)
          )
        );
        sessionStorage.setItem(
          "PricingGap",
          JSON.stringify(
            mathRound(Number(formData.estimated12Months), 0.1031)
          )
        );
        sessionStorage.setItem(
          "MaterialOptimization",
          JSON.stringify(mathRound(formData.onHandInventory, 0.0886))
        );
        if(formData.numberOfPlants < 5){
          sessionStorage.setItem(
            "IncrementalNetworkOptimization",
            "No Data Provided"
          );
        } else {
          sessionStorage.setItem(
            "IncrementalNetworkOptimization",
            JSON.stringify(mathRound(formData.onHandInventory, 0.0289))
          );
        }
        window.location.href = "https://verusen.com/?page_id=3903&preview=true";
      })
      .catch((error) => {
        console.error("Error sending data to HubSpot:", error);
      });
  };

  return { sendToHubSpot };
};
